import React from 'react'
import PropTypes, { string } from 'prop-types'
import * as Styled from './TextBox.styles'

const TextBox = ({ title, children, ...rest }) => (
  <Styled.TextBox { ...rest }>
    <p>
      <b>{title}</b>
    </p>
    {children}
  </Styled.TextBox>
)

TextBox.defaultProps = {
  title: string.isRequired,
  children: PropTypes.node.isRequired,
}

export default TextBox
